import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { CloneProjectArgs, Project } from '@ztechapps/common.contract'
import { projectDocumentFragment } from './graphql'

export const cloneProjectQuery = gql`
  mutation cloneProject($input: CloneProjectArgs!) {
    cloneProject(input: $input) {
      ...projectDocumentFragment
    }
  }
  ${projectDocumentFragment}
`

export const useCloneProject = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<Project, CloneProjectArgs> => {
  query = query ?? cloneProjectQuery

  return useActionMutation({
    query,
    ...props,
  })
}
